<div
  class="upload-box-container"
  [style.width]="width"
  [style.height]="height"
  [class.drag-over]="isDragOver"
  [class.disabled]="disabled"
  [attr.tabindex]="disabled ? -1 : 0"
  (click)="triggerFileInput()"
  (keydown.enter)="triggerFileInput()"
  (keydown.space)="$event.preventDefault(); triggerFileInput()"
  [attr.aria-disabled]="disabled"
  [attr.aria-label]="placeholder | translate"
>
  <!-- Upload Icon -->
  <div class="upload-icon">
    <ion-icon name="add-circle-outline"></ion-icon>
  </div>

  <!-- Placeholder Text -->
  <p class="upload-text">{{ placeholder | translate }}</p>

  <!-- Hidden File Input -->
  <input
    #fileInput
    type="file"
    tabindex="-1"
    [multiple]="multiple"
    [attr.accept]="getAcceptAttribute()"
    (change)="onFileSelected($event)"
    (cancel)="onFileDialogCancel()"
    class="hidden-file-input"
  />
</div>

<!-- Processing Overlay (optional) -->
<div class="processing-overlay" *ngIf="isProcessing">
  <div class="spinner"></div>
</div>
